import {
  DashboardData,
  VideosUploadedData,
  InterviewsConductedData,
} from "../types";
import { LocationDataRaw } from "../utils/api";

// Helper function to generate random data within ranges
const randomBetween = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min + 1)) + min;
const randomFloat = (min: number, max: number) =>
  Math.random() * (max - min) + min;

/**
 * Array of all US states
 * @type {string[]}
 */
// DO NOT CHANGE THESE VALUES!!!
export const states = [
  { name: "Alabama", value: "us-al", center: [-87, 33], zoom: 6.5 },
  {
    name: "Alaska",
    value: "us-ak",
    center: [-152.1953, 66.1326],
    zoom: 4,
    exportCenter: [-120, 0],
    exportZoom: 6,
  },
  { name: "Arizona", value: "us-az", center: [-112, 35], zoom: 6 },
  { name: "Arkansas", value: "us-ar", center: [-92, 35], zoom: 6.5 },
  { name: "California", value: "us-ca", center: [-120, 38], zoom: 5.5 },
  { name: "Colorado", value: "us-co", center: [-106, 39], zoom: 6.5 },
  { name: "Connecticut", value: "us-ct", center: [-73, 42], zoom: 7 },
  { name: "Delaware", value: "us-de", center: [-75, 39], zoom: 7 },
  { name: "Florida", value: "us-fl", center: [-82, 29], zoom: 5.75 },
  { name: "Georgia", value: "us-ga", center: [-84, 33], zoom: 6 },
  {
    name: "Hawaii",
    value: "us-hi",
    center: [-158, 22],
    zoom: 6,
    exportCenter: [-102, 0],
    exportZoom: 7,
  },
  { name: "Idaho", value: "us-id", center: [-115, 45], zoom: 5.75 },
  { name: "Illinois", value: "us-il", center: [-89, 40], zoom: 6 },
  { name: "Indiana", value: "us-in", center: [-86, 40], zoom: 6 },
  { name: "Iowa", value: "us-ia", center: [-93, 42], zoom: 6 },
  { name: "Kansas", value: "us-ks", center: [-98, 39], zoom: 6 },
  { name: "Kentucky", value: "us-ky", center: [-85, 38], zoom: 6 },
  { name: "Louisiana", value: "us-la", center: [-92, 31], zoom: 6 },
  { name: "Maine", value: "us-me", center: [-69, 45], zoom: 6 },
  { name: "Maryland", value: "us-md", center: [-77, 39], zoom: 6.5 },
  { name: "Massachusetts", value: "us-ma", center: [-72, 42], zoom: 6.5 },
  { name: "Michigan", value: "us-mi", center: [-85, 45], zoom: 6 },
  { name: "Minnesota", value: "us-mn", center: [-94, 46], zoom: 6 },
  { name: "Mississippi", value: "us-ms", center: [-90, 33], zoom: 6.25 },
  { name: "Missouri", value: "us-mo", center: [-93, 39], zoom: 6 },
  { name: "Montana", value: "us-mt", center: [-109, 47], zoom: 6 },
  { name: "Nebraska", value: "us-ne", center: [-100, 42], zoom: 6.25 },
  { name: "Nevada", value: "us-nv", center: [-117, 39], zoom: 6 },
  { name: "New Hampshire", value: "us-nh", center: [-71, 44], zoom: 6.5 },
  { name: "New Jersey", value: "us-nj", center: [-75, 40], zoom: 6.75 },
  { name: "New Mexico", value: "us-nm", center: [-106, 34], zoom: 6 },
  { name: "New York", value: "us-ny", center: [-75, 43], zoom: 6 },
  { name: "North Carolina", value: "us-nc", center: [-79, 36], zoom: 6.5 },
  { name: "North Dakota", value: "us-nd", center: [-100, 48], zoom: 6 },
  { name: "Ohio", value: "us-oh", center: [-83, 40], zoom: 6 },
  { name: "Oklahoma", value: "us-ok", center: [-97, 35], zoom: 6 },
  { name: "Oregon", value: "us-or", center: [-121, 44], zoom: 6 }, //
  { name: "Pennsylvania", value: "us-pa", center: [-78, 41], zoom: 6.5 },
  { name: "Rhode Island", value: "us-ri", center: [-71.56, 41.74], zoom: 8.5 },
  {
    name: "South Carolina",
    value: "us-sc",
    center: [-80.83, 33.97],
    zoom: 6.5,
  },
  { name: "South Dakota", value: "us-sd", center: [-100.09, 44.46], zoom: 6.5 },
  { name: "Tennessee", value: "us-tn", center: [-86.36, 35.85], zoom: 6.75 },
  { name: "Texas", value: "us-tx", center: [-98, 31], zoom: 5.25 },
  { name: "Utah", value: "us-ut", center: [-111.55, 39.61], zoom: 6 },
  { name: "Vermont", value: "us-vt", center: [-72.7, 44.05], zoom: 6.75 },
  { name: "Virginia", value: "us-va", center: [-79, 38], zoom: 6.5 },
  { name: "Washington", value: "us-wa", center: [-120.61, 47.44], zoom: 6.25 },
  {
    name: "West Virginia",
    value: "us-wv",
    center: [-80.55, 38.96],
    zoom: 6.75,
  },
  { name: "Wisconsin", value: "us-wi", center: [-89.89, 44.68], zoom: 6 },
  { name: "Wyoming", value: "us-wy", center: [-107, 43], zoom: 6 },
];

// DO NOT CHANGE THESE VALUES!!!
export const ageDistributionData = [
  {
    name: "0-4 Years",
    desc: "ages of 0 and 4.",
    value: "2%",
  },
  {
    name: "5-9 Years",
    desc: "ages of 5 and 9.",
    value: "22%",
  },
  {
    name: "10-15 Years",
    desc: "ages of 10 and 15.",
    value: "55%",
  },
  {
    name: "16-21 Years",
    desc: "ages of 16 and 21.",
    value: "19%",
  },
  {
    name: "22+ Years",
    desc: "ages of 22 and above.",
    value: "1%",
  },
];

// Generate monthly data for charts
const generateMonthlyData = (baseValue: number, variance: number = 0.2) => {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun"];
  return months.map((month) => ({
    month,
    interviews:
      Math.floor(baseValue * (1 + (Math.random() - 0.5) * variance)) + 10000,
    uploads: Math.floor(
      baseValue * 0.7 * (1 + (Math.random() - 0.5) * variance)
    ),
  }));
};

// Generate center locations for map
const generateCenterLocations = (count: number) => {
  const locations = [];
  const types = ["CAC", "Prosecutor", "Law Enforcement"] as const;

  for (let i = 0; i < count; i++) {
    locations.push({
      name: `Center ${i + 1}`,
      lat: randomFloat(25.0, 49.0), // US latitude range
      lng: randomFloat(-125.0, -66.0), // US longitude range
      type: types[Math.floor(Math.random() * types.length)],
    });
  }

  return locations;
};

/**
 * National aggregated data (baseline)
 * @type {DashboardData}
 * @example
 * {
 *   "stats": {
 *     "childrenProtected": number,
 *     "centersSupported": number,
 *     "individualUsers": number,
 *     "agenciesUsingGuardify": number
 *   },
 *   "interviewActivity": {
 *     "totalInterviews": number,
 *     "cumulativeInterviews": number,
 *     "monthlyData": Array<{
 *       "month": string,
 *       "interviews": number
 *     }>
 *   },
 *   "ageDistribution": {
 *     "categories": Array<{
 *       "name": string,
 *       "value": number,
 *       "color": string
 *     }>
 *   },
 *   "videosUploaded": {
 *     "totalUploads": number,
 *     "cumulativeTotal": number,
 *     "monthlyData": Array<{
 *       "month": string,
 *       "uploads": number
 *     }>
 *   },
 *   "agenciesEngaged": {
 *     "categories": Array<{
 *       "name": string,
 *       "percentage": number,
 *       "color": string
 *     }>
 *   },
 *   "agencyCoverage": {
 *     "centers": Array<{
 *       "name": string,
 *       "lat": number,
 *       "lng": number,
 *       "type": "CAC" | "Prosecutor" | "Law Enforcement"
 *     }>
 *   },
 *   "qualifiedSavings": {
 *     "totalSavings": number,
 *     "totalHours": number,
 *     "workDays": number,
 *     "workWeeks": number,
 *     "breakdown": Array<{
 *       "category": string,
 *       "amount": number,
 *       "color": string
 *     }>
 *   }
 * }
 */
export const nationalData: DashboardData = {
  stats: {
    childrenProtected: 367447,
    centersSupported: 638,
    individualUsers: 89171,
    agenciesUsingGuardify: 367447,
  },
  interviewsConducted: {
    totalInterviews: 18200,
    cumulativeInterviews: 42200,
    monthlyData: [
      { month: "Apr", interviews: 31000 },
      { month: "May", interviews: 34500 },
      { month: "Jun", interviews: 28000 },
      { month: "Jul", interviews: 32000 },
      { month: "Aug", interviews: 29500 },
      { month: "Oct", interviews: 27000 },
    ],
  },
  ageDistribution: {
    categories: [
      { name: "0-4 Years", value: 12 },
      { name: "5-9 Years", value: 28 },
      { name: "10-15 Years", value: 38 },
      { name: "16-21 Years", value: 18 },
      { name: "22+ Years", value: 4 },
    ],
  },
  videosUploaded: {
    totalUploads: 14435,
    cumulativeTotal: 14775,
    monthlyData: [
      { month: "Jan", uploads: 2200 },
      { month: "Feb", uploads: 2150 },
      { month: "Mar", uploads: 2300 },
      { month: "Apr", uploads: 2500 },
      { month: "May", uploads: 2400 },
      { month: "Jun", uploads: 2885 },
    ],
  },
  agenciesEngaged: {
    categories: [
      { name: "Law Enforcement", percentage: 46, color: "#3B82F6" },
      { name: "CPS", percentage: 25, color: "#8B5CF6" },
      { name: "Prosecution", percentage: 11, color: "#06B6D4" },
      { name: "CAC", percentage: 8, color: "#10B981" },
      { name: "Defense", percentage: 7, color: "#F59E0B" },
      { name: "Other", percentage: 3, color: "#EF4444" },
    ],
  },
  agencyCoverage: {
    centers: generateCenterLocations(150),
  },
  qualifiedSavings: {
    totalSavings: 63400000,
    totalHours: 208578,
    workDays: 26072,
    workWeeks: 8691,
    breakdown: [
      {
        category: "DVD Creation & Distribution",
        amount: 40000000,
        color: "#3B82F6",
      },
      { category: "Long Term Storage", amount: 17000000, color: "#8B5CF6" },
      { category: "Transcription", amount: 6400000, color: "#06B6D4" },
    ],
  },
};

// Generate state-specific data
const generateStateData = (stateName: string): DashboardData => {
  const populationFactor = randomFloat(0.1, 2.0); // Scaling factor based on state size

  return {
    stats: {
      childrenProtected: Math.floor(
        nationalData.stats.childrenProtected * populationFactor * 0.02
      ),
      centersSupported: Math.floor(
        nationalData.stats.centersSupported * populationFactor * 0.05
      ),
      individualUsers: Math.floor(
        nationalData.stats.individualUsers * populationFactor * 0.03
      ),
      agenciesUsingGuardify: Math.floor(
        nationalData.stats.agenciesUsingGuardify * populationFactor * 0.02
      ),
    },
    interviewsConducted: {
      totalInterviews: Math.floor(
        nationalData.interviewsConducted.totalInterviews *
          populationFactor *
          0.02
      ),
      cumulativeInterviews: Math.floor(
        nationalData.interviewsConducted.cumulativeInterviews *
          populationFactor *
          0.02
      ),
      monthlyData: generateMonthlyData(500 * populationFactor),
    },
    ageDistribution: {
      categories: nationalData.ageDistribution.categories.map((cat) => ({
        ...cat,
        value: Math.max(1, cat.value + randomBetween(-5, 5)),
      })),
    },
    videosUploaded: {
      totalUploads: Math.floor(
        nationalData.videosUploaded.totalUploads * populationFactor * 0.02
      ),
      cumulativeTotal: Math.floor(
        nationalData.videosUploaded.cumulativeTotal * populationFactor * 0.02
      ),
      monthlyData: generateMonthlyData(400 * populationFactor).map((item) => ({
        month: item.month,
        uploads: item.uploads,
      })),
    },
    agenciesEngaged: {
      categories: nationalData.agenciesEngaged.categories.map((cat) => ({
        ...cat,
        percentage: Math.max(1, cat.percentage + randomBetween(-3, 3)),
      })),
    },
    agencyCoverage: {
      centers: generateCenterLocations(Math.floor(5 * populationFactor)),
    },
    qualifiedSavings: {
      totalSavings: Math.floor(
        nationalData.qualifiedSavings.totalSavings * populationFactor * 0.02
      ),
      totalHours: Math.floor(
        nationalData.qualifiedSavings.totalHours * populationFactor * 0.02
      ),
      workDays: Math.floor(
        nationalData.qualifiedSavings.workDays * populationFactor * 0.02
      ),
      workWeeks: Math.floor(
        nationalData.qualifiedSavings.workWeeks * populationFactor * 0.02
      ),
      breakdown: nationalData.qualifiedSavings.breakdown.map((item) => ({
        ...item,
        amount: Math.floor(item.amount * populationFactor * 0.02),
      })),
    },
  };
};

/**
 * Organization-specific data for individual organization dashboard
 * @type {DashboardData}
 * @example
 * {
 *   "stats": {
 *     "childrenProtected": number,
 *     "centersSupported": number,
 *     "individualUsers": number,
 *     "agenciesUsingGuardify": number
 *   },
 *   "interviewsConducted": {
 *     "totalInterviews": number,
 *     "cumulativeInterviews": number,
 *     "monthlyData": Array<{
 *       "month": string,
 *       "interviews": number
 *     }>
 *   },
 *   "ageDistribution": {
 *     "categories": Array<{
 *       "name": string,
 *       "value": number,
 *       "color": string
 *     }>
 *   },
 *   "videosUploaded": {
 *     "totalUploads": number,
 *     "cumulativeTotal": number,
 *     "monthlyData": Array<{
 *       "month": string,
 *       "uploads": number
 *     }>
 *   },
 *   "agenciesEngaged": {
 *     "categories": Array<{
 *       "name": string,
 *       "percentage": number,
 *       "color": string
 *     }>
 *   },
 *   "agencyCoverage": {
 *     "centers": Array<{
 *       "name": string,
 *       "lat": number,
 *       "lng": number,
 *       "type": "CAC" | "Prosecutor" | "Law Enforcement"
 *     }>
 *   },
 *   "qualifiedSavings": {
 *     "totalSavings": number,
 *     "totalHours": number,
 *     "workDays": number,
 *     "workWeeks": number,
 *     "breakdown": Array<{
 *       "category": string,
 *       "amount": number,
 *       "color": string
 *     }>
 *   }
 * }
 */
export const organizationData: DashboardData = {
  stats: {
    childrenProtected: 2847,
    centersSupported: 1,
    individualUsers: 156,
    agenciesUsingGuardify: 23,
  },
  interviewsConducted: {
    totalInterviews: 342,
    cumulativeInterviews: 891,
    monthlyData: [
      { month: "Apr", interviews: 65 },
      { month: "May", interviews: 72 },
      { month: "Jun", interviews: 58 },
      { month: "Jul", interviews: 69 },
      { month: "Aug", interviews: 47 },
      { month: "Oct", interviews: 31 },
    ],
  },
  ageDistribution: {
    categories: [
      { name: "0-4 Years", value: 12 },
      { name: "5-9 Years", value: 28 },
      { name: "10-15 Years", value: 38 },
      { name: "16-21 Years", value: 18 },
      { name: "22+ Years", value: 4 },
    ],
  },
  videosUploaded: {
    totalUploads: 287,
    cumulativeTotal: 312,
    monthlyData: [
      { month: "Jan", uploads: 45 },
      { month: "Feb", uploads: 42 },
      { month: "Mar", uploads: 48 },
      { month: "Apr", uploads: 52 },
      { month: "May", uploads: 49 },
      { month: "Jun", uploads: 51 },
    ],
  },
  agenciesEngaged: {
    categories: [
      { name: "Law Enforcement", percentage: 52, color: "#3B82F6" },
      { name: "CPS", percentage: 21, color: "#8B5CF6" },
      { name: "Prosecution", percentage: 13, color: "#06B6D4" },
      { name: "CAC", percentage: 9, color: "#10B981" },
      { name: "Defense", percentage: 4, color: "#F59E0B" },
      { name: "Other", percentage: 1, color: "#EF4444" },
    ],
  },
  agencyCoverage: {
    centers: generateCenterLocations(8),
  },
  qualifiedSavings: {
    totalSavings: 1247000,
    totalHours: 4186,
    workDays: 523,
    workWeeks: 174,
    breakdown: [
      { category: "DVD Creation", amount: 780000, color: "#3B82F6" },
      { category: "Long Term Storage", amount: 341000, color: "#8B5CF6" },
      { category: "Transcription", amount: 126000, color: "#06B6D4" },
    ],
  },
};

/**
 * State-specific data for each US state
 * @type {Record<string, DashboardData>}
 * @example
 * {
 *   "California": {
 *     "stats": {
 *       "childrenProtected": number,
 *       "centersSupported": number,
 *       "individualUsers": number,
 *       "agenciesUsingGuardify": number
 *     },
 *     "interviewsConducted": {
 *       "totalInterviews": number,
 *       "cumulativeInterviews": number,
 *       "monthlyData": Array<{
 *         "month": string,
 *         "interviews": number,
 *         "uploads": number
 *       }>
 *     },
 *     "ageDistribution": {
 *       "categories": Array<{
 *         "name": string,
 *         "value": number,
 *         "color": string
 *       }>
 *     },
 *     "videosUploaded": {
 *       "totalUploads": number,
 *       "cumulativeTotal": number,
 *       "monthlyData": Array<{
 *         "month": string,
 *         "uploads": number
 *       }>
 *     },
 *     "agenciesEngaged": {
 *       "categories": Array<{
 *         "name": string,
 *         "percentage": number,
 *         "color": string
 *       }>
 *     },
 *     "agencyCoverage": {
 *       "centers": Array<{
 *         "name": string,
 *         "lat": number,
 *         "lng": number,
 *         "type": "CAC" | "Prosecutor" | "Law Enforcement"
 *       }>
 *     },
 *     "qualifiedSavings": {
 *       "totalSavings": number,
 *       "totalHours": number,
 *       "workDays": number,
 *       "workWeeks": number,
 *       "breakdown": Array<{
 *         "category": string,
 *         "amount": number,
 *         "color": string
 *       }>
 *     }
 *   }
 * }
 */
export const stateData: Record<string, DashboardData> = {};
states.forEach((state) => {
  if (state.name !== "All States") {
    stateData[state.name.toLowerCase()] = generateStateData(state.name);
  }
});

/**
 * Complete mock data object containing all dashboard data
 * @type {Object}
 * @example
 * {
 *   "nationalData": {
 *     "stats": { "childrenProtected": number, "centersSupported": number },
 *     "interviewsConducted": { "totalInterviews": number, "cumulativeInterviews": number },
 *     "ageDistribution": { "categories": Array<{ "name": string, "value": number, "color": string }> },
 *     "videosUploaded": { "totalUploads": number, "cumulativeTotal": number },
 *     "agenciesEngaged": { "categories": Array<{ "name": string, "percentage": number, "color": string }> },
 *     "agencyCoverage": { "centers": Array<{ "name": string, "lat": number, "lng": number, "type": string }> },
 *     "qualifiedSavings": { "totalSavings": number, "totalHours": number }
 *   },
 *   "organizationData": {
 *     "name": string,
 *     "stats": { "childrenProtected": number, "centersSupported": number },
 *     "interviewsConducted": { "totalInterviews": number, "cumulativeInterviews": number },
 *     "ageDistribution": { "categories": Array<{ "name": string, "value": number, "color": string }> },
 *     "videosUploaded": { "totalUploads": number, "cumulativeTotal": number },
 *     "agenciesEngaged": { "categories": Array<{ "name": string, "percentage": number, "color": string }> },
 *     "agencyCoverage": { "centers": Array<{ "name": string, "lat": number, "lng": number, "type": string }> },
 *     "qualifiedSavings": { "totalSavings": number, "totalHours": number }
 *   },
 *   "stateData": {
 *     "California": { "stats": { "childrenProtected": number }, "interviewsConducted": { "totalInterviews": number } },
 *     "Texas": { "stats": { "childrenProtected": number }, "interviewsConducted": { "totalInterviews": number } },
 *     ...
 *   }
 * }
 */
export const impactData = {
  nationalData,
  organizationData,
  stateData,
};

// --- API Data Mapping ---

/**
 * Maps the raw API response from /impact-report and /location-data to DashboardData.
 */
export function mapApiToDashboardData(
  impactRows: Array<Record<string, unknown>>,
  locations: Array<LocationDataRaw>,
  centerId?: string,
  agenciesCount?: number
): DashboardData {
  // Color palettes for mapping
  const agencyColors = [
    "#3B82F6",
    "#8B5CF6",
    "#06B6D4",
    "#10B981",
    "#F59E0B",
    "#EF4444",
  ];

  // Strict 12-month window ending with the current month (e.g. on 2026-05-18
  // this yields "2025-06"). Defends the chart from stale rows that may carry
  // older months in their JSON, regardless of what the BQ query produced.
  const now = new Date();
  const cutoffDate = new Date(now.getFullYear(), now.getMonth() - 11, 1);
  const cutoffMonth = `${cutoffDate.getFullYear()}-${String(
    cutoffDate.getMonth() + 1
  ).padStart(2, "0")}`;

  let totalUsers = 0;
  let totalVideos = 0;
  let totalInterviews = 0;
  let cumulativeInterviews = 0;
  let totalAgencies = 0;
  let totalAgeDistribution = 0;
  let centerName = "";
  let state = "";
  const activityByAgencyTypeMap = new Map<string, number>();
  const interviewsConductedMonthlyMap = new Map<string, number>();
  const videosUploadedMonthlyMap = new Map<string, number>();
  const ageDistributionMap = new Map<string, number>();
  for (const impact of impactRows) {
    totalUsers += Number(impact.totalUsers) || 0;
    totalVideos += Number(impact.totalVideos) || 0;
    cumulativeInterviews += Number(impact.totalInterviews) || 0;

    if (centerId) {
      if (impact.centerId === centerId) {
        centerName = impact.centerName ? String(impact.centerName) : "";
        state = impact.state ? String(impact.state) : "";
      }
    }

    const activityByAgencyTypeRow = impact.activityByAgencyType as Array<{
      count: number;
      orgType: string;
    }>;
    for (const entry of activityByAgencyTypeRow) {
      totalAgencies += entry.count || 0;
      if (!activityByAgencyTypeMap.has(entry.orgType)) {
        activityByAgencyTypeMap.set(entry.orgType, 0);
      }
      activityByAgencyTypeMap.set(
        entry.orgType,
        activityByAgencyTypeMap.get(entry.orgType)! + (entry.count || 0)
      );
    }

    const interviewsConductedMonthlyRow =
      impact.interviewsConductedMonthly as Array<{
        month: string;
        interviews: number;
      }>;
    for (const entry of interviewsConductedMonthlyRow) {
      if (entry.month < cutoffMonth) continue;
      totalInterviews += entry.interviews || 0;
      if (!interviewsConductedMonthlyMap.has(entry.month)) {
        interviewsConductedMonthlyMap.set(entry.month, 0);
      }
      interviewsConductedMonthlyMap.set(
        entry.month,
        interviewsConductedMonthlyMap.get(entry.month)! +
          (entry.interviews || 0)
      );
    }

    const videosUploadedMonthlyRow = impact.videosUploadedMonthly as Array<{
      month: string;
      uploads: number;
    }>;
    for (const entry of videosUploadedMonthlyRow) {
      if (entry.month < cutoffMonth) continue;
      if (!videosUploadedMonthlyMap.has(entry.month)) {
        videosUploadedMonthlyMap.set(entry.month, 0);
      }
      videosUploadedMonthlyMap.set(
        entry.month,
        videosUploadedMonthlyMap.get(entry.month)! + (entry.uploads || 0)
      );
    }

    const ageDistributionRow = impact.ageOfSurvivors as Array<{
      count: number;
      ageGroup: string;
    }>;
    for (const entry of ageDistributionRow) {
      totalAgeDistribution += entry.count || 0;
      if (!ageDistributionMap.has(entry.ageGroup)) {
        ageDistributionMap.set(entry.ageGroup, 0);
      }
      ageDistributionMap.set(
        entry.ageGroup,
        ageDistributionMap.get(entry.ageGroup)! + (entry.count || 0)
      );
    }
  }

  // Qualified Savings Constants
  const DVD_SAVINGS_PER = 133.18;
  const STORAGE_SAVINGS_PER = 22.95;
  const TRANSCRIPTION_SAVINGS_PER = 141.7;
  const HOURS_SAVED_PER = 8; // 3 from DVD, 5 from transcription

  // Utah override: the canonical count of Utah CACs is 23. The cacheImpactReport
  // can be missing rows for centers without recent BQ metrics, so we force the
  // displayed number when we're in a state-scoped view of Utah (not single-center).
  const isStateScopedToUtah =
    !centerId &&
    impactRows.length > 0 &&
    impactRows.every(
      (r) => String((r as { state?: unknown }).state || "").toUpperCase() === "UT"
    );
  const centersSupported = isStateScopedToUtah ? 23 : Number(impactRows.length) || 0;

  return {
    stats: {
      childrenProtected: Number(cumulativeInterviews) || 0,
      centersSupported,
      individualUsers: Number(totalUsers) || 0,
      agenciesUsingGuardify:
        typeof agenciesCount === "number"
          ? agenciesCount
          : Number(totalAgencies) || 0,
    },
    interviewsConducted: {
      totalInterviews: totalInterviews || 0,
      cumulativeInterviews: cumulativeInterviews || 0,
      monthlyData: Array.from(interviewsConductedMonthlyMap.entries())
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([month, interviews]) => ({
          month,
          interviews,
        })),
    },
    ageDistribution: {
      categories: Array.from(ageDistributionMap.entries()).map(
        ([ageGroup, count]) => ({
          name: ageGroup,
          value: Math.round((count / totalAgeDistribution) * 100),
        })
      ),
    },
    videosUploaded: {
      totalUploads: Array.from(videosUploadedMonthlyMap.values()).reduce(
        (sum, uploads) => sum + uploads,
        0
      ),
      cumulativeTotal: totalVideos || 0,
      monthlyData: Array.from(videosUploadedMonthlyMap.entries())
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([month, uploads]) => ({
          month,
          uploads,
        })),
    },
    agenciesEngaged: {
      categories: Array.from(activityByAgencyTypeMap.entries()).map(
        ([orgType, count], i) => ({
          name: orgType,
          percentage: Math.round((count / totalAgencies) * 100),
          color: (agencyColors[i % agencyColors.length] as string) || "#000000",
        })
      ),
    },
    agencyCoverage: {
      centers: locations.map((loc, i) => ({
        name: loc.city || loc.address || `Center ${i + 1}`,
        lat: loc.lat,
        lng: loc.lng,
        type:
          loc.type === 2
            ? "CAC"
            : loc.type === 4
            ? "Prosecutor"
            : "Law Enforcement",
      })),
    },
    qualifiedSavings: {
      totalSavings:
        cumulativeInterviews *
        (DVD_SAVINGS_PER + STORAGE_SAVINGS_PER + TRANSCRIPTION_SAVINGS_PER),
      totalHours: cumulativeInterviews * HOURS_SAVED_PER,
      workDays: Math.round((cumulativeInterviews * HOURS_SAVED_PER) / 8),
      workWeeks: Math.round((cumulativeInterviews * HOURS_SAVED_PER) / 40),
      breakdown: [
        {
          category: "DVD Creation & Distribution",
          amount: cumulativeInterviews * DVD_SAVINGS_PER,
          color: "#3B82F6",
        },
        {
          category: "Long Term Storage",
          amount: cumulativeInterviews * STORAGE_SAVINGS_PER,
          color: "#8B5CF6",
        },
        {
          category: "Transcription",
          amount: cumulativeInterviews * TRANSCRIPTION_SAVINGS_PER,
          color: "#06B6D4",
        },
      ],
    },
    centerName: centerName,
    state: state,
  };
}
